import React, { useState } from 'react'
import classNames from 'classnames'

import Button from '../../Button/Button'
import Icon from '../../Icon2/Icon'
import RenderQuery from './RenderQuery'
import MatchTag from './MatchTag'
import { advanceQueryOpts } from '../util/constant'

const RenderAdvanceQuery = (props) => {
  let [activeSuggestionIndex, setActiveSuggestionIndex] = useState(-1)

  const openAutoComplete = (e, index) => {
    if (activeSuggestionIndex !== index) {
      setActiveSuggestionIndex(index)
      props.setDropdownOpen(true)
    }
  }

  const closeAutoComplete = () => {
    setActiveSuggestionIndex(-1)
    props.setDropdownOpen(false)
  }

  let isWhite = typeof props.isWhite === 'boolean' ? props.isWhite : true
  // let disabledSubCond = props.disabledSubCond || false

  return props.advanceQueryArray.map((queryObj, index) => {
    const foundOpt = advanceQueryOpts.find((opt) => opt.value === queryObj.queryType)
    const queryArray = queryObj.queryArray

    return (
      <div
        style={{
          background: isWhite ? '#fff' : '#f7f9fc',
          marginLeft: queryObj.root ? '' : '24px',
          marginBottom: '16px',
          border: queryObj.root ? '' : '1px solid #dde3ee'
        }}
        data-test-id={`cs-advance-search-query-wrapper-${queryObj.cursorY}`}
        className={classNames('query-wrapper', queryObj.cursorY === queryObj.error_cursor && 'query-wrapper-error')}
        key={index}>
        <div className={classNames('matchTag-wrapper', !queryObj.root && 'matchTag-wrapper-connector')}>
          <MatchTag
            matchOption={foundOpt}
            updateAdvancedQueryArray={props.updateAdvancedQueryArray}
            queryObj={queryObj}
            cursorY={props.cursorY}
            setDropdownOpen={props.setDropdownOpen}
            isDropdownOpen={props.isDropdownOpen}
            isVisible={props.isVisible}
          />
          {!queryObj.root && (
            <Button
              buttonType="light"
              className="ml-3"
              size="regular"
              version="v2"
              // data-testid="removeQueryGroup"
              testId="cs-advance-search-remove-query-group"
              onClick={() => {
                props.handleQueryRemove({
                  queryObject: queryObj,
                  currentAdvQueryArray: props.advanceQueryArray,
                  queryObjIndex: index,
                  // queryIndex: index,
                  currentQuery: props.query,
                  action: 'removeQueryGroup'
                })
              }}
              onlyIcon={true}>
              <Icon version="v2" icon="CloseNoborder" size="medium" className="queryGroup-remove-icon" />
            </Button>
          )}
        </div>
        {queryArray.map((query, nestedIndex) => {
          return (
            <RenderQuery
              query={query}
              key={index + nestedIndex}
              queryObj={queryObj}
              advanceQueryArray={props.advanceQueryArray}
              queryObjIndex={index}
              queryIndex={nestedIndex}
              handleQueryRemove={props.handleQueryRemove}
              openAutoComplete={(e, type) => openAutoComplete(e, `${queryObj.cursorY}-${index}-${nestedIndex}-${type}`)}
              activeSuggestionIndex={activeSuggestionIndex}
              closeAutoComplete={closeAutoComplete}
              fetchData={props.fetchData}
              queryArray={queryArray}
              updateAdvancedQueryArray={props.updateAdvancedQueryArray}
              selectedModule={props.selectedModule}
              parentQueryObject={props.parentQueryObject}
              isTaxonomyPlanEnabled={props.isTaxonomyPlanEnabled}
              cursorY={props.cursorY}
              cursorX={props.cursorX}
              setDropdownOpen={props.setDropdownOpen}
              isDropdownOpen={props.isDropdownOpen}
              isVisible={props.isVisible}
            />
          )
        })}
        {queryObj.children && queryObj.children.length > 0 && (
          <RenderAdvanceQuery
            parentQueryObject={queryObj}
            advanceQueryArray={queryObj.children}
            isWhite={!isWhite}
            handleConditionClick={props.handleConditionClick}
            handleQueryRemove={props.handleQueryRemove}
            disabledSubCond={true}
            fetchData={props.fetchData}
            updateAdvancedQueryArray={props.updateAdvancedQueryArray}
            selectedModule={props.selectedModule}
            isTaxonomyPlanEnabled={props.isTaxonomyPlanEnabled}
            cursorY={props.cursorY}
            cursorX={props.cursorX}
            setDropdownOpen={props.setDropdownOpen}
            isDropdownOpen={props.isDropdownOpen}
            isVisible={props.isVisible}
          />
        )}
        <div className="query-wrapper-nestedButton flex-v-center ml-24">
          <Button
            testId="cs-advance-search-add-condition"
            buttonType="secondary"
            size="large"
            className="mr-15"
            onClick={() => {
              console.log('new cond clicked')
              props.handleConditionClick({ action: 'addCondition', queryObject: queryObj })
            }}>
            <Icon version="v2" icon="Plus" size="small" />
            New Condition
          </Button>
          <Button
            testId="cs-advance-search-add-sub-condition"
            buttonType="secondary"
            size="large"
            onClick={() => {
              console.log('new sub cond clicked')
              props.handleConditionClick({ action: 'addSubCondition', queryObject: queryObj })
            }}>
            <Icon version="v2" icon="Plus" size="small" />
            New Sub-condition
          </Button>
          {/* {!disabledSubCond && (
          )} */}
        </div>
      </div>
    )
  })
}

export default RenderAdvanceQuery
